/**
 * The footer credit, shared by the member and public footers. Its own module
 * so the public page does not pull in Layout and the bingo easter egg.
 */
export const FOOTER_CREDIT = '© Lewolff • Ram Ranch Consulting • 2026'
